// extracted by mini-css-extract-plugin
module.exports = {"platform":"PlatformName__platform___26cbU","useWFFonts":"PlatformName__useWFFonts___3gIQS"};